import script from "./byProperty.vue?vue&type=script&lang=ts&setup=true"
export * from "./byProperty.vue?vue&type=script&lang=ts&setup=true"

import "./byProperty.vue?vue&type=style&index=0&id=d89b1e1c&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d89b1e1c"]])

export default __exports__